module.exports = __webpack_public_path__ + "static/microsoft-surface-book@2x-c0e60d7ed305872ae03d69f6a9a37b20.png";